export default {
  mounted() {
    const name = this.$options.name;
    const type = name?.split("-")?.at(-1);
    if (type === "view" && !this.keepLoading) {
      this.$loading(false);
    }
  },
};
